const Page = theme => {
  return {
    width: '100%',
    background: 'rgba(255,255,255,1)',
    '& h1': {
      textTransform: 'uppercase',
      fontWeight: 800,
    },
    '& h2': {
      textTransform: 'uppercase',
      fontWeight: 100,
      lineHeight: 1
    },
    '& h3': {
      textTransform: 'uppercase',
      fontWeight: 100,
      lineHeight: 1,
    },
  }
}

export default Page



// WEBPACK FOOTER //
// ./src/styles/mixins/page.js